<template>
    <div>
        <nav class="bar bar-nav home-bar-nav" >
            <a class="icon pull-left open-panel" @click="onPanelClick()">
                <img src="https://mobile.rcclchina.com.cn/Themes/RcclMobileTheme/Images/home_iconmenu2.png" alt=""
                    style="vertical-align: initial;">
                <span class="nav-title">完善信息</span>
            </a>
            <div class="right-icon" v-if="isShowCancelBtn">
                <a class="perfectTheInformationLater external" @click="cancenBtnClick()">
                    <span class="nav-title">稍后完善</span>
                    <img class="addInfo-arrow" src="https://resource.rcclchina.com.cn/userCenter/arrowWhiteRightB.png" alt="">
                </a>

            </div>
        </nav>
        <div class="page page-current noScroll">
            <div class="page-content infinite-scroll noScroll" style="overflow-x: hidden;">
                <div class="addInfo-wrap scroll-container">
                    <!--提示-->
                    <div class="addInfo-tips">
                        <span>!</span>填写信息必须与护照保持一致。
                    </div>
                    <div class="privacy-layout">
                      <privacy-button @privacy-switch="reload" type="btn-mini" :refresh="refresh"></privacy-button>
                    </div>
                    <div class="addInfo-info-bg" v-if="canGetReward">
                        完善资料领取200积分
                    </div>
                    <div class="addInfo-row" @click="showSelector">
                        <div class="addInfo-title">国家或地区</div>
                        <input style="color: #333" class="addInfo-input js_nationality" type="text" placeholder="必填" v-model="subInfo.Nationality" readonly>
                        <img class="addInfo-arrow" src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightB.png" alt="">
                    </div>
                    <div class="addInfo-wrapper c_addInfo-wrapper">
                        <div class="addInfo-row c_addInfo-row">
                            <div class="addInfo-title">中文姓</div>
                            <div class="addInfo-input">
                                <input id="lastName" data-key="LastName" type="text" placeholder="必填" v-model="subInfo.LastName" maxlength="4" :disabled="!canLastNameEdit"
                                       @change="handlerLastName" @focus="txtFocus">
                            </div>
                        </div>
                        <div class="addInfo-row c_addInfo-row">
                            <div class="addInfo-title c_addInfo-title">中文名</div>
                            <div class="addInfo-input">
                                <input id="firstName" data-key="FirstName" type="text" placeholder="必填" v-model="subInfo.FirstName" maxlength="4" :disabled="!canFirstNameEdit"
                                       @change="handlerFirstName" @focus="txtFocus">
                            </div>
                        </div>
                    </div>
                    <div class="addInfo-wrapper c_addInfo-wrapper">
                        <div class="addInfo-row c_addInfo-row">
                            <div class="addInfo-title">拼音姓</div>
                            <div class="addInfo-input">
                                <input id="lastNamePY" name="LastNamePinYin" data-key="LastNamePinYin" type="text" placeholder="必填"  v-model="subInfo.LastNamePinYin"
                                       :disabled="!canLastNamePingyinEdit" @focus="txtFocus">
                            </div>
                        </div>
                        <div class="addInfo-row  c_addInfo-row">
                            <div class="addInfo-title c_addInfo-title">拼音名</div>
                            <div class="addInfo-input">
                                <input id="firstNamePY" data-key="FirstNamePinYin" @focus="txtFocus" type="text" placeholder="必填" v-model="subInfo.FirstNamePinYin"
                                       :disabled="!canFirstNamePingyinEdit">
                            </div>
                        </div>
                    </div>
                    <div class="addInfo-row">
                        <div class="addInfo-title">性别</div>
                        <div class="addInfo-gender">
                            <div class="addInfo-radio" data-key="Gender" v-bind:class="{active: subInfo.Gender === 'M'}" data-gender="男" @click="selectGender('M')">
                                <div class="addInfo-radio-icon"></div>
                                男
                            </div>
                            <div class="addInfo-radio" data-key="Gender" v-bind:class="{active: subInfo.Gender === 'F'}" data-gender="女" @click="selectGender('F')">
                                <div class="addInfo-radio-icon"></div>
                                女
                            </div>
                        </div>
                    </div>
                    <div class="addInfo-row">
                        <div class="addInfo-title" v-bind:class="{disabled: !canDateOfBirthEdit}">出生日期</div>
                        <input placeholder="必填" v-model="subInfo.DateOfBirthStr" name="birth-date" data-key="DateOfBirth" @focus="txtFocus" class="birth-date addInfo-input"
                               :disabled="!canDateOfBirthEdit">
                        <div class="calendarIcon">
                            <img src="https://resource.rcclchina.com.cn/tui2/user_center/calender-icon_blue.png">
                        </div>
                    </div>
                    <div class="addInfo-row">
                        <div class="add-phone">
                            <div class="addInfo-title disabled">手机号</div>
                            <input class="addInfo-input disabled" data-key="Mobile" disabled="" type="text" maxlength="11" placeholder="必填" v-model="userInfo.mobile">

                        </div>
                    </div>
                    <div class="addInfo-row">
                        <div class="addInfo-title">电子邮箱</div>
                        <input class="addInfo-input" data-key="Email" @focus="txtFocus" type="email" placeholder="必填" v-model="subInfo.Email">
                    </div>

                    <div class="checkbox-bar" @click="marketingFlagEmailChange">
                      <span class="checkBox-btn" :class="{'active':subInfo.marketingFlagEmail }">
                        <img src="https://resource.rcclchina.com.cn/paySuccess/check.png" alt="">
                      </span>
                      <div>我同意<span class="is-important">电子邮箱</span>接受皇家加勒比品牌资讯及优惠信息</div>
                    </div>
                </div>
            </div>
            <CountrySelector ref="countrySelector" :isShow="isShowCountrySelector" :onCountrySelected="selectCountry" :onCountryClose="closeSelector"></CountrySelector>

            <!-- 保存按钮 -->
            <div class="infoSubmitBtn" @click="saveInfo(userInfo.infoIntegrity)">保存</div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import CountrySelector from '@/components/Booking/CountrySelector.vue'
    import { dateFormat } from '@/utilities/tools'
    import 'pickerjs/dist/picker.css'
    import Picker from 'pickerjs'
    import { isChinese, isLetter, checkMail } from '@/utilities/tools'
    const PrivacyButton = () => import('@/components/Common/PrivacyButton')
    export default {
        name: 'EditInfo',
        components: {
            CountrySelector,
            PrivacyButton
        },
        data () {
            return {
                userInfo: {},
                canLastNameEdit: true,
                canFirstNameEdit: true,
                canLastNamePingyinEdit: true,
                canFirstNamePingyinEdit: true,
                canDateOfBirthEdit: true,
                isShowCountrySelector: false,
                subInfo: {
                    userName: '',
                    FirstName: '',
                    LastName: '',
                    FirstNamePinYin: '',
                    LastNamePinYin: '',
                    Gender: '',
                    DateOfBirth: '',
                    Nationality: '',
                    Email: '',
                    marketingFlagEmail: false
                },
                dateOfBirth: '',
                birthPicker: null,
                updateFields: [],
                refresh: null
            }
        },
        beforeMount () {
            this.$store.commit('HIDE_HEADER_BAR', {isHideFooter: true, isHideHeader: true})
            this.showPage()
        },
        beforeDestroy () {
            this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
            
        },
        methods: {
            reload() {
              this.showPage();
              this.refresh = new Date().getTime();
            },
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                const userToken = this.$store.state.user.userToken
                if (!userToken && userToken.length == 0) {
                    this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
                    return
                }
                const data = await this.getEditInfo(userToken)
                this.userInfo = data
                // 可编辑与否
                this.canLastNameEdit = data.customerEditable.canLastNameEdit
                this.canFirstNameEdit = data.customerEditable.canFirstNameEdit
                this.canLastNamePingyinEdit = data.customerEditable.canLastNamePingyinEdit
                this.canFirstNamePingyinEdit = data.customerEditable.canFirstNamePingyinEdit
                this.canDateOfBirthEdit = data.customerEditable.canDateOfBirthEdit

                // 存储国家
                this.$store.commit('SET_COUNTRIES', data.nationalityApiViews)
                //初始化提交数据
                this.subInfo.userName = userToken
                this.subInfo.FirstName = data.firstName
                this.subInfo.LastName = data.lastName
                this.subInfo.FirstNamePinYin = data.firstNamePinYin
                this.subInfo.LastNamePinYin = data.lastNamePinYin
                this.subInfo.Gender = data.gender
                this.subInfo.DateOfBirth = data.dateOfBirth
                this.subInfo.DateOfBirthStr = data.dateOfBirthStr
                this.subInfo.Nationality = data.nationality
                this.subInfo.Email = data.email
                this.subInfo.marketingFlagEmail = data.marketingFlagEmail
                // 初始化区域
                this.dateOfBirth = dateFormat(data.dateOfBirth, 'YYYY-MM-DD')
                this.dateOfBirthStr = dateFormat(data.dateOfBirthStr, 'YYYY-MM-DD')

                // picker实例化
                this.birthPicker = this.initPicker('请选择出生日期(年/月/日)', '.birth-date', this.dateOfBirth, () => {
                    let pickerDate = this.birthPicker.getDate(true)
                    let pickerTime = new Date(pickerDate).getTime()
                    let currentTime = new Date().getTime()
                    if (pickerTime > currentTime) {
                        this.dateOfBirthStr = ''
                        this.subInfo.DateOfBirthStr = ''
                        this.$alert.show('请选择正确的出生日期')
                    } else if (pickerTime + 18 * 365 * 24 * 60 * 60 * 1000 > currentTime) {
                        this.dateOfBirthStr = ''
                        this.subInfo.DateOfBirthStr = ''
                        this.$alert.show('抱歉！我们识别到您未满18周岁，暂时无法入会，请重新填写您的出生日期。')
                    } else {
                        this.subInfo.DateOfBirthStr = pickerDate
                        this.dateOfBirthStr = pickerDate
                    }
                })
            },
            async getEditInfo (userName) {
                const {success, data, errMsg} = await api.user.userEditInfo(userName)
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            onPanelClick () {
                this.$store.dispatch('SET_NAV_PANEL', true)
            },
            showSelector () {
                this.isShowCountrySelector = true
            },
            selectCountry (countryCode) {
                let countries = this.$store.state.page.countries
                let item = countries.find(item => item.countryCode === countryCode)
                this.subInfo.Nationality = item.countryName

                // 关闭浮层
                this.isShowCountrySelector = false
                if(!this.updateFields.includes('Nationality')) {
                  this.updateFields.push('Nationality')
                }
            },
            closeSelector () {
                this.isShowCountrySelector = false
            },
            selectGender (gender) {
                this.subInfo.Gender = gender
                if(!this.updateFields.includes('Gender')) {
                  this.updateFields.push("Gender")
                }
            },
            // async pyName ({lastName, firstName}) {
            //     const {Success, Data} = await api.page.pyName({lastName, firstName})
            //     if (!Success) console.log('获取拼音失败')
            //     if (Data.FirstName) {
            //         this.subInfo.FirstNamePinYin = Data.FirstName
            //     }
            //     if (Data.LastName) {
            //         this.subInfo.LastNamePinYin = Data.LastName
            //     }
            // },
            async handlerLastName () {
              if (!this.subInfo.LastName || this.subInfo.LastName.length == 0) {
                return
              }
              const data = await this.getPinYin(this.subInfo.LastName)
              console.log(data)
              if (!data || data.length == 0) return
              this.subInfo.LastNamePinYin = data
            },
            async handlerFirstName () {
              if (!this.subInfo.FirstName || this.subInfo.FirstName.length == 0) {
                return
              }
              const data = await this.getPinYin(this.subInfo.FirstName)
              if (!data || data.length == 0) return
              this.subInfo.FirstNamePinYin = data
            },
            async getPinYin (name) {
              try {
                const { data, success } = await api.page.getPinyin(name)
                if (success) {
                  return data
                }
              } catch (error) {
                console.log(error)
              }
              return ""
            },
            initPicker (title, selector, date, pick) {
                return new Picker(document.querySelector(selector), {
                    format: 'YYYY-MM-DD',
                    text: {
                        title: title,
                        cancel: '取消',
                        confirm: '确认'
                    },
                    date,
                    pick
                });
            },
            async saveInfo (infoIntegrity) {
                let subInfo = this.subInfo
                if(this.updateFields.length === 0) {
                  this.$alert.show('没有任何修改')
                  return false
                }

                if (!subInfo.Nationality) {
                    this.$alert.show('请选择国家和地区')
                    return false
                }
                if (!subInfo.LastName) {
                  this.$alert.show('请输入中文姓')
                  return false
                }
                if(!this.isMaskValue || this.updateFields.includes("LastName")) {
                  if (!isChinese(subInfo.LastName)) {
                      this.$alert.show('请输入正确的中文姓')
                      return false
                  }
                }

                if (!subInfo.FirstName) {
                    this.$alert.show('请输入中文名')
                    return false
                }
                if(!this.isMaskValue || this.updateFields.includes("FirstName")) {
                  if (!isChinese(subInfo.FirstName)) {
                      this.$alert.show('请输入正确的中文名')
                      return false
                  }
                }

                if (!this.isMaskValue) {
                  if(this.updateFields.includes('LastName')) {
                    this.updateFields.push('LastNamePinYin')
                  }
                  if(this.updateFields.includes('FirstName')) {
                    this.updateFields.push('FirstNamePinYin')
                  }
                }

                if (!subInfo.LastNamePinYin) {
                    this.$alert.show('请输入拼音姓')
                    return false
                }
                if(!this.isMaskValue || this.updateFields.includes("LastNamePinYin")) {
                  if (!isLetter(subInfo.LastNamePinYin)) {
                      this.$alert.show('请输入正确的拼音姓')
                      return false
                  }
                }

                if (!subInfo.FirstNamePinYin) {
                    this.$alert.show('请输入拼音名')
                    return false
                }
                if(!this.isMaskValue || this.updateFields.includes("FirstNamePinYin")) {
                  if (!isLetter(subInfo.FirstNamePinYin)) {
                    this.$alert.show('请输入正确的拼音名')
                    return false
                  }
                }

                if (!subInfo.Gender) {
                    this.$alert.show('请选择性别')
                    return false
                }
                if (!subInfo.DateOfBirthStr) {
                    this.$alert.show('请输入出生日期')
                    return false
                }
                if (!subInfo.Email) {
                    this.$alert.show('请输入电子邮箱')
                    return false
                }
                if(!this.isMaskValue || this.updateFields.includes("Email")) {
                  if (!checkMail(subInfo.Email)) {
                    this.$alert.show('请输入正确的电子邮箱')
                    return false
                  }
                }
                //提交数据
                await this.submitInfo(infoIntegrity)
            },
            cancenBtnClick () {
                this.$confirm.show('完善信息后积分方可累计，</br>是否继续完善？', {
                    cancelCallBack: ()=> {
                        // this.submitInfo()
                        // 点击取消不保存用户信息 直接返回
                        this.goBack()
                    }
                })
            },
            async submitInfo (infoIntegrity) {
                this.$loading.show()
                this.subInfo.updateFields = this.updateFields;
                this.subInfo.DateOfBirth = this.subInfo.DateOfBirthStr;
                const {success, errMsg} = await api.user.subEditInfo(this.subInfo)
                this.$loading.hide()
                if (!success) {
                    this.$alert.show(errMsg)
                    return false
                }
                await this.rewardLevelAndCredit(infoIntegrity)
            },
            // 积分里程回溯接口
            async rewardLevelAndCredit (infoIntegrity) {
                this.$loading.show()
                await api.user.memberUpdateLevelAndCredit()
                this.$loading.hide()
                let self = this
                if (infoIntegrity < 100) {
                    this.$alert.show('恭喜您获得200积分', {
                        confirmCallBack: () => {
                            self.goBack()
                        }
                    })
                } else if (infoIntegrity >= 100){
                    this.$alert.show('提交成功', {
                        confirmCallBack: () => {
                            self.goBack()
                        }
                    })
                } else {
                    self.goBack()
                }
            },
            goBack () {
                const query = this.$router.currentRoute.query;
                if (query && query.returnUrl && query.returnUrl.length > 0) {
                    location.href = query.returnUrl
                } else {
                    location.href = `/Rccl.Campaign/MemberCenter/Auth?redirectUrl=${encodeURIComponent(process.env.VUE_APP_REWARD_URL+'/reward/member/index')}`
                }
            },
          txtFocus(e) {
            let dataKey = e.target.getAttribute('data-key')
            console.log(dataKey)
            if(!this.canLastNameEdit && dataKey === 'LastName') return;
            if(!this.canLastNamePingyinEdit && dataKey === 'LastNamePinYin') return;
            if(!this.canFirstNameEdit && dataKey === 'FirstName') return;
            if(!this.canFirstNamePingyinEdit && dataKey === 'FirstNamePinYin') return;
            if(!this.canDateOfBirthEdit  && dataKey === 'DateOfBirth') return;

            if (this.isMaskValue) {
              if(dataKey === 'LastName' || dataKey === 'LastNamePinYin') {
                if(!this.updateFields.includes("LastName") || !this.updateFields.includes("LastNamePinYin")) {
                  this.subInfo.LastName = "";
                  this.subInfo.LastNamePinYin = "";
                  this.updateFields.push("LastName");
                  this.updateFields.push("LastNamePinYin");
                }
              }

              if (dataKey === 'FirstName' || dataKey === 'FirstNamePinYin') {
                if(!this.updateFields.includes("FirstName") || !this.updateFields.includes("FirstNamePinYin")) {
                  this.subInfo.FirstName = "";
                  this.subInfo.FirstNamePinYin = "";
                  this.updateFields.push("FirstName");
                  this.updateFields.push("FirstNamePinYin");
                }
              }

              if(dataKey === 'DateOfBirth') {
                if(!this.updateFields.includes("DateOfBirth")) {
                  this.subInfo.DateOfBirth = "";
                  this.updateFields.push("DateOfBirth");
                }
              }

              if(dataKey === 'PassportExpire') {
                if(!this.updateFields.includes("PassportExpire")) {
                  this.subInfo.PassportExpireStr = "";
                  this.updateFields.push("PassportExpire");
                }
              }
              if(!this.updateFields.includes(dataKey)) {
                Object.keys(this.subInfo).filter(r => {
                  if (dataKey.toUpperCase() === r.toUpperCase()) {
                    this.subInfo[r] = "";
                    return r
                  }
                });
              }
            }

            if(!this.updateFields.includes(dataKey)) {
              this.updateFields.push(dataKey);
            }
          },
          marketingFlagEmailChange() {
            this.subInfo.marketingFlagEmail = !this.subInfo.marketingFlagEmail;
            if(!this.updateFields.includes("MarketingFlagEmail")) {
              this.updateFields.push("MarketingFlagEmail");
            }
          }
        },
        computed: {
            isShowCancelBtn () {
                return this.userInfo && this.userInfo.memberLevelStr && this.userInfo.memberLevelStr.length > 0
                && this.userInfo.infoIntegrity < 100
            },
            isMaskValue() {
              return this.$store.state.page.isMaskValue;
            },
            canGetReward() {
              let userInfo = this.$store.state.user.userInfo;
              let isLocalReward = userInfo && userInfo?.userIdentity && userInfo.userIdentity === 1
              console.log(userInfo.infoIntegrity)
              return isLocalReward && userInfo.infoIntegrity < 100;
            }
        }
    }
</script>
<style lang="less" scoped>
.checkbox-bar {
  display: flex;
  margin-top: 15px;
  font-size: 13px;
  gap: 0 5px;
  color: #000;
  & .is-important {
    color: #FF0004;
  }
  & .checkBox-btn{
    width: 16px;
    height: 16px;
    border: 2px solid #D8D8D8;
    background: #FFFFFF;
    border-radius: 4px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2px;
    & img{
      width: 10px;
      height: 7px;
    }
  }
  & .checkBox-btn.active{
    background-color: #FCC300;
    border: none;
  }
}
</style>
<style scoped>
    body>#content>.zone-content{
        position: fixed;
        width: 100%;
    }
    .page{
        padding-top: 50px;
    }
    /*护照示例*/
    .example-img{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 99999;
        padding-top: 50px;
        display: none;
    }
    .example-img>img{
        width: 100%;
    }


    .c_province_city_js{
        color: #777!important;
    }
    .c_province_city_js span{
        color: #333;
    }
    .footer-nav {
        display:none;
    }

    .view-addInfo .page-content {
        padding-top: 50px;
        padding-bottom: 50px;
        background: #F6F7F8;
    }

    .c_addInfo-wrapper{
        border-bottom: 1px solid #E5E5E5;
    }
    .addInfo-wrap {
        margin-bottom:10px;
        padding:0 20px 20px;
        background:#fff;
    }

    .addInfo-row {
        position: relative;
        display:flex;
        align-items:center;
        width:100%;
        height:43px;
        border-bottom:1px solid #E5E5E5;
    }
    .addInfo-row.c_addInfo-row{
        border-bottom:0;
    }
    .addInfo-title {
        flex:none;
        width:100px;
        font-size:14px;
        line-height:20px;
        color:#333;
    }
    .addInfo-title.c_addInfo-title{
        padding-top: 2px;
    }

    .addInfo-title.disabled {
        color: #444;
    }

    .addInfo-input {
        flex: 1;
        display: block;
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        color: #333;
        -webkit-appearance: none;
        outline: none;
        border: none;
        border-radius: 0;
        padding: 0;
        background-color: transparent;
        position: relative;
        z-index: 1;
    }
    .addInfo-input.disabled {
        color: #444;
    }
    .addInfo-input > input {
        display: block;
        width: 100%;
        height: 100%;
        -webkit-appearance: none;
        outline: none;
        border: none;
        border-radius: 0;
        padding: 0;
        background-color: transparent;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .addInfo-gender {
        display: flex;
        align-items: center;
    }

    .addInfo-radio {
        display: flex;
        align-items: center;
        margin-right:45px;
        font-size: 14px;
        line-height: 20px;
        color: #333;
    }
    .addInfo-radio-icon {
        position: relative;
        width: 14px;
        height: 14px;
        margin-right: 10px;
        border-radius: 50%;
        border: 1px solid #4A90E2;
    }
    .addInfo-radio.active .addInfo-radio-icon::before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #4A90E2;
    }

    .calendarIcon {
        width: 19px;
        position: absolute;
        right: 2px;
        top: 11px;
    }
    .calendarIcon img {
        display:block;
        width:100%;
    }
    .infoSubmitBtn {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 10;
        width: 100%;
        height: 50px;
        background-image: linear-gradient(270deg, #FAD961 0%, #FEBC10 100%);
        font-size: 16px;
        line-height: 50px;
        color: #454545;
        letter-spacing: 5px;
        text-align: center;
        font-weight: bolder;
    }
    /**完善信息页面新的样式*/
    .addInfo-tips{
        line-height: 34px;
        font-size: 12px;
        color: #FF5055;
        text-align: center;
        /*margin-right: -20px;*/
        letter-spacing: 0.86px;
        position: relative;
    }
    .addInfo-tips>span{
        display: inline-block;
        width:12px;
        height: 12px;
        border-radius: 50%;
        background-color: #F4BF44;
        line-height: 12px;
        text-align: center;
        color: #fff;
        margin-right: 2px;
    }
    .addInfo-info-bg{
        line-height: 20px;
        font-size:12px;
        color: #333;
        text-align: center;
        background: #F4BF44;
        margin-left: -20px;
        margin-right: -20px;
        letter-spacing: 0.855px;
    }
    .addInfo-arrow{
        width: 8px;
        vertical-align: -2px;
        margin-left: 4px;
    }
    .addInfo-wrapper{
        display: flex;
    }
    .addInfo-wrapper>.addInfo-row{
        width: 50%;
    }
    .addInfo-row.add-row{
        flex-wrap: wrap;
        height: 85px;
    }
    .add-phone{
        /*margin-bottom: 8px;*/
        display: flex;
    }
    .add-per{
        display: flex;
        position:relative;
    }
    .addInfo-example{
        position: absolute;
        width: 47px;
        right: 1px;
        top: 9px;
        z-index: 1;
    }
    .addInfo-example>span{
        font-size: 14px;
        color: #4A90E2;
    }
    .addInfo-example>img{
        width: 14px;
        vertical-align: text-bottom;
        margin-right: 5px;
    }
    .addInfo-title.c_addInfo-title{
        width: 90px;
    }
    .passport-tips-popup {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2001;
        text-align: center;
    }

    .passport-tips-popup .bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
    }

    .passport-tips-popup .tips-image {
        position: relative;
        margin-top: 100px;
        width: 78.8%;
        left: 10.1%;
        display: block;
    }

    .passport-tips-popup .close-btn {
        position: relative;
        width: 50px;
        margin-top: 25px;
        display: inline-block;
    }

    .passport-tips-popup img {
        width: 100%;
    }

    .privacy-layout {
      position: absolute;
      top: 0.25rem;
      right: 0.5rem;
      font-size: 0;
      line-height: 1;
    }
</style>
